/*
 Created by CHT 2019/9/17 15:38
 */
import {
  DEFAULT_VALUE__ADDRESS,
  DEFAULT_VALUE__CREATE_TIME,
  DEFAULT_VALUE__CUSTOM,
  DEFAULT_VALUE__FILE,
  DEFAULT_VALUE__FORMULA,
  DEFAULT_VALUE__IMAGE,
  DEFAULT_VALUE__MEMBER,
  DEFAULT_VALUE__RELATE_DATA
} from "./types"

/**
 * @param prefix
 * @return {string}
 */
export function uuid(prefix) {
  prefix = prefix || ''
  let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  let uuid = []
  const len = 8
  const radix = chars.length
  for (let i = 0; i < len; i++) {
    uuid[i] = chars[0 | Math.random() * radix]
  }
  return prefix + Date.now().toString(36) + uuid.join('')
}

export function defaultValueInit(type, val = null) {
  switch (type) {
    case DEFAULT_VALUE__CUSTOM:
      return {
        defaultType: DEFAULT_VALUE__CUSTOM,
        customValue: val
      }
    case DEFAULT_VALUE__FORMULA:
      return {
        defaultType: DEFAULT_VALUE__FORMULA,
        formulaExpr: '',
        paramList: [
          {
            // formId,
            // fieldTitle,
            // fieldType,
            // isSameTable,
            // envVarName
          }
        ]
      }
    case DEFAULT_VALUE__RELATE_DATA:
      return {
        defaultType: DEFAULT_VALUE__RELATE_DATA,

        relateAppId: '',  // 关联的appId
        relateFormId: '', // 对应表单Id
        formTitle: '',  	// 所关联的表单Title

        // 条件
        localFieldId: '',     // 匹配的fieldId
        localFieldTitle: '',  // 匹配的fieldTitle
        matchType: 0,         // 0 字段 1 公式

        // 公式的时候
        functionInfo: {
          function: '',       //公式信息
          paramList: []
        },

        // 公式的时候 字段值的时候
        remoteFieldId: '',    // 匹配远端的fieldId
        remoteFieldTitle: '', // 匹配远端的fieldTitle

        // 联动显示的数据
        dataSourceFieldId: '',    // 数据源ID
        dataSourceFieldTitle: ''  // 数据源title
      }

    case DEFAULT_VALUE__ADDRESS:
      return {
        defaultType: DEFAULT_VALUE__ADDRESS,
        defaultAddress: {
          province: "",
          city: "",
          county: "",
          detailAddress: ""
        }
      }
    case DEFAULT_VALUE__FILE:
      return {
        defaultType: DEFAULT_VALUE__FILE,
        files: [
          // {
          // 	"fileName":"",    // 文件名称
          // 	"fileSize":25.21, // 文件大小 KB
          // 	"fileUrl":"",     // 图片地址
          // 	"fileType":"",    // 文件类型
          // 	"id":"123"        // 前端使用
          // }
        ]
      }
    case DEFAULT_VALUE__IMAGE:
      return {
        defaultType: DEFAULT_VALUE__IMAGE,
        imgs: [
          // {
          // 	"imgName":"",     // 图片名称
          // 	"imgSize":25.21,  // 文件大小 KB
          // 	"imgUrl":"",      // 图片地址
          // 	"id":"123"        // 前端使用
          // }
        ]
      }
    case DEFAULT_VALUE__MEMBER:
      return {
        defaultType: DEFAULT_VALUE__MEMBER,
        defaultMember: {
          depart: [], //部门
          member: [], //成员
          role: [] //角色
        }
      }
    case DEFAULT_VALUE__CREATE_TIME:
      return {
        defaultType: DEFAULT_VALUE__CREATE_TIME
      }
    default:
      return {}
  }
}

export function getId(cur) {
  return cur ? cur.dataId : null
}

// 格式化日期
export function formatDate(d) {
  // if (d > 0) {
    let date = new Date(d)
    return fmt => { //author: meizz
      let o = {
        'M+': date.getMonth() + 1, //月份
        'd+': date.getDate(), //日
        'H+': date.getHours(), //小时
        'm+': date.getMinutes(), //分
        's+': date.getSeconds(), //秒
        'q+': Math.floor((date.getMonth() + 3) / 3), //季度
        'S': date.getMilliseconds() //毫秒
      }
      if (/(y+)/.test(fmt)) {
        fmt =
          fmt.replace(RegExp.$1, (date.getFullYear() + ``).substr(4 - RegExp.$1.length))
      }
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          fmt =
            fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : ((`00` + o[k]).substr(
              (`` + o[k]).length)))
        }
      }
      return fmt
    }
  // } else {
  //   return (d) => {
  //     return ``
  //   }
  // }
}
